import Backbone from 'backbone'
import _ from 'lodash'
import i18n from './i18n'
import * as urlToLinks from './urls-to-links'
import template from './license-restriction.hbs'

const LicenseRestriction = Backbone.View.extend({

	className: 'license-restriction',

	render: function() {
		let link = urlToLinks.createAnchor('mailto:support@spiderstrategies.com','support@spiderstrategies.com')
		let context = _.extend({
			contact: i18n.get('license.restriction.contact',
				this.options.enableType, link)
		}, this.options)

		this.$el.html(template(context))
		this.$('.details').prepend(this.details())
		return this
	}

})

const SharedDashboardRestriction = LicenseRestriction.extend({
	initialize: function(options = {}) {
		this.options = {
			dialogHeader: i18n.get('admin.shareDashboard'),
			headerDescription: i18n.get('license.restriction.sharedDashboards.details1'),
			headerIcon: 'dashboard-restricted-license',
			headline: i18n.get('license.restriction.shareYourDashboards'),
			enableType: i18n.get('license.restriction.sharedDashboards')
		}
	},

	details: function() {
		let link = urlToLinks.createAnchor('https://support.spiderstrategies.com/hc/en-us/articles/360041177132-Sharing-and-Embedding-Dashboards', 'license.restriction.sharingAndEmbeddingDashboards')
		let html = `<p>${i18n.get('license.restriction.sharedDashboards.details2', link)}</p>`
		return html
	}
})

const SharedStrategyMapRestriction = LicenseRestriction.extend({
	initialize: function(options = {}) {
		this.options = {
			dialogHeader: i18n.get('license.restriction.shareStrategyMap'),
			headerDescription: i18n.get('license.restriction.sharedStrategyMaps.details1'),
			headerIcon: 'dashboard-restricted-license',
			headline: i18n.get('license.restriction.shareYourStrategyMaps'),
			enableType: i18n.get('license.restriction.sharedStrategyMaps')
		}
	},

	details: function() {
		let link = urlToLinks.createAnchor('https://support.spiderstrategies.com/hc/en-us/articles/360041177132-Sharing-and-Embedding-Dashboards', 'license.restriction.sharingAndEmbeddingStrategyMaps')
		let html = `<p>${i18n.get('license.restriction.sharedStrategyMaps.details2', link)}</p>`
		return html
	}
})

const exportTypeMsgKeys = ['common.export.pdf.abbr','common.export.word',
	'common.export.powerpoint.abbr', 'common.export.excel',
	'common.export.png']

const ExportRestriction = LicenseRestriction.extend({

	initialize: function(options = {}) {
		this.options = {
			dialogHeader: i18n.get('common.export'),
			headerDescription: i18n.get('license.restriction.export.details1'),
			headerIcon: 'export-restricted-license',
			headline: i18n.get('license.restriction.exportYourData'),
			enableType: i18n.get('license.restriction.dataExporting')
		}
	},

	details: function() {
		let listContents = _.reduce(exportTypeMsgKeys, (res, key) => {
			res += `<li>${i18n.get(key)}</li>`
			return res
		}, '')
		let list = `<ul>${listContents}</ul>`
		let html = `<p>${i18n.get('license.restriction.export.details2', list)}</p>`
		let link = urlToLinks.createAnchor('https://support.spiderstrategies.com/hc/en-us/articles/360041612951-Overview-of-Exports', 'license.restriction.overviewOfExports')
		html +=  `<p>${i18n.get('license.restriction.export.details3', link)}</p>`
		return html
	}
})

const DailyCalendarRestriction = LicenseRestriction.extend({
	initialize: function(options = {}) {
		this.options = {
			dialogHeader: i18n.get('license.restriction.addDailyCalendar'),
			headerDescription: i18n.get('license.restriction.dailyCalendar.details1'),
			headerIcon: 'calendar-restricted-license',
			headline: i18n.get('license.restriction.trackDailyMetrics'),
			enableType: i18n.get('license.restriction.dailyKpis')
		}
	},

	details: function() {
		return `<p>${i18n.get('license.restriction.dailyCalendar.details2')}</p>`
	}
})

const SharedFormRestriction = LicenseRestriction.extend({
	initialize: function(options = {}) {
		this.options = {
			dialogHeader: i18n.get('admin.shareForm'),
			headerDescription: i18n.get('license.restriction.sharedForms.details1'),
			// TODO - change icon once we have one for shared forms
			headerIcon: 'dashboard-restricted-license',
			headline: i18n.get('license.restriction.shareYourForms'),
			enableType: i18n.get('license.restriction.sharedForms')
		}
	},

	details: function() {
		// the link is the same as the one for shared dashboards
		// ("Sharing Dashboards, Strategy Maps, and Forms")
		let link = urlToLinks.createAnchor('https://support.spiderstrategies.com/hc/en-us/articles/360041177132-Sharing-and-Embedding-Dashboards', 'license.restriction.sharingAndEmbeddingForms')
		let html = `<p>${i18n.get('license.restriction.sharedForms.details2', link)}</p>`
		return html
	}
})

const exportRestriction = () => new ExportRestriction()
const sharedDashboardRestriction = () => new SharedDashboardRestriction()
const sharedStrategyMapRestriction = () => new SharedStrategyMapRestriction()
const dailyCalendarRestriction = () => new DailyCalendarRestriction()
const sharedFormRestriction = () => new SharedFormRestriction()

_.extend(LicenseRestriction, {
	exportRestriction,
	sharedDashboardRestriction,
	sharedStrategyMapRestriction,
	dailyCalendarRestriction,
	sharedFormRestriction
})
export default LicenseRestriction

LicenseRestriction.__filename__ = 'components/license-restriction.js'
